// Wortlaute der Erklärung „Dateien“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Bereiche stehen so, wie der Dateibrowser sie zeigt (../file.js).
export default {
  title: "Dateien",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    FileBrowser: "Dateien",
    ProjectDetail: "Projekt",
    SettingsOverview: "Einstellungen",
  },
  // Die Seiten außerhalb des Browsers, aus denen seine Dateien kommen. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    intro: {
      text: "Hier finden Sie alle Dateien Ihres Betriebs an einer Stelle. Jede Datei gehört weiter zu ihrem Datensatz, etwa zu einem Projekt oder einem Kunden.",
    },
    places: {
      text: "Links steht jede Ablage, in der Dateien liegen. Die Zahl dahinter sagt, wie viele es darunter sind.",
    },
    search: {
      text: "Die Suche findet Ordner und Dateien im ganzen Betrieb. Sie sucht auch in den Schlagworten.",
    },
    "due-filter": {
      text: "Dieser Filter zeigt nur Dateien, die abgelaufen sind, bald ablaufen oder noch gültig sind.",
    },
    storage: {
      text: "Der Balken zeigt, wie viel Speicher Ihr Betrieb belegt. Ist er voll, nimmt Lewara keine Datei mehr an.",
    },
    place: {
      text: "Eine Ablage listet die Datensätze, an denen Dateien hängen. Jede Zeile sagt, wie viele es sind.",
    },
    record: {
      text: "Der Pfad zeigt, wo Sie gerade stehen, und führt mit einem Klick zurück. Darunter steht, was der Ordner enthält.",
    },
    list: {
      text: "Ordner stehen oben, darunter die Dateien. Ein Klick auf eine Spaltenüberschrift sortiert die Liste.",
    },
    upload: {
      text: "Hochladen legt eine Datei direkt an diesem Datensatz ab. Sie können Dateien auch in die Liste ziehen.",
    },
    owner: {
      text: "Dieser Link öffnet den Datensatz selbst, also hier das Projekt mit allem, was sonst daran hängt.",
    },
    "due-column": {
      text: "Gültig bis sagt, wann ein Dokument abläuft. Die Farbe wechselt, sobald die Frist näher rückt.",
    },
    details: {
      text: "Ein Klick auf eine Zeile öffnet die Datei: Bilder und PDF verkleinert in der Vorschau, alles andere in diesem Fenster. Das Original gibt es über Herunterladen.",
    },
    "details-meta": {
      text: "Schlagworte machen eine Datei auffindbar. Das Dokumentdatum hält fest, was auf dem Dokument steht, auch wenn es später hochgeladen wurde. Gültig bis legt fest, bis wann die Datei gilt und wie früh Lewara warnt.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: woher die Dateien kommen und was das Ablaufdatum auslöst.
    "project-files": {
      text: "Hochgeladen werden Dateien am Datensatz selbst, hier am Projekt. Unter Dateien finden Sie dieselben wieder.",
    },
    "notify-documents": {
      text: "Ablaufende Dokumente meldet die Glocke. Hier legen Sie fest, wie viele Tage vorher gewarnt wird.",
    },
    rights: {
      text: "Die Rechte einer Rolle entscheiden, welche Ablagen der Dateibrowser zeigt und in welchen Sie hochladen dürfen.",
    },
  },
}
